import React, { useEffect } from 'react'
import styles from './index.module.css';
import Select from 'react-select';
import {IoCloseSharp} from 'react-icons/io5';
import {arrayForSelect} from '../../../../utils/arrayForSelect';
import {createChat, getUsers} from '../../../../actions/lk';
import {createNotification} from '../../../notifications/notifications';
import {useDispatch, useSelector} from 'react-redux';

const Index = ({ newChat, setNewChat }) => {

    const dispatch = useDispatch();
    const users = useSelector((state) => state.lk.users);    

    useEffect(() => {
        if (newChat
            ?.type) {
            dispatch(getUsers(newChat.type));
        }
    }, [
        dispatch, newChat
            ?.type
    ]);

    const handleSubmit = () => {
        const {mid, title, message} = newChat || {};
        if (!mid) 
            return createNotification('error', 'Выберите пользователя');
        if (title.trim().length < 1) 
            return createNotification('error', 'Введите тему');
        if (message.trim().length < 1) 
            return createNotification('error', 'Введите сообщение');
        
        dispatch(createChat(newChat, mid));
        setNewChat(null);
    };

    const arrSelectUser = arrayForSelect([{ mid: null, fullName: 'Выберите пользователя' } ,...users], 'fullName', 'mid');
    const handleSelectChange = (option) => {
        setNewChat((prev) => ({
            ...prev,
            mid: option
                ?.value,
            value: option
                ?.label
        }));
    };

    const handleSelectType = (value) => {
        setNewChat((prev) => ({
            ...prev,
            type: value,
            mid: null,
            value: 'Выберите пользователя'
        }));
    };

    const renderRadioOption = (label, value) => (
        <div
            key={value}
            className={styles.radioTypeItem}
            onClick={() => handleSelectType(value)}>
            <input
                type="radio"
                id={value}
                name="userType"
                value={value}
                checked={newChat
                ?.type === value}
                readOnly/>
            <label htmlFor={value}>{label}</label>
        </div>
    );

    return (
        <div className={styles.newChatWrapper}>
            <div className={styles.newChatPopup}>
                <div className={styles.newChatTitle}>
                    <span>Начать новый диалог</span>
                    <IoCloseSharp onClick={() => setNewChat(null)}/>
                </div>

                <div className={styles.newChatSelect}>
                    {renderRadioOption('Постоянный состав', 'constant')}
                    {renderRadioOption('Переменный состав', 'temporary')}
                </div>

                <div className={styles.newChatSearch}>
                    <div className={styles.newChatInputTitle}>Выберите пользователя</div>
                    <Select
                        placeholder="Выберите получателя"
                        noOptionsMessage={() => 'ничего не найдено'}
                        styles={{
                        control: (base) => ({
                            ...base,
                            borderColor: '#7b2b2a',
                            borderRadius: '8px',
                            fontSize: '14px',
                            padding: '5px 13px',
                            color: '#202020'
                        })
                    }}
                        onChange={handleSelectChange}
                        value={arrSelectUser.find((el) => el.value === newChat
                            ?.mid) }
                        options={arrSelectUser}/>
                </div>

                <div className={styles.newChatTheme}>
                    <div className={styles.newChatInputTitle}>Тема переписки</div>
                    <input
                        className={styles.newChatInput}
                        placeholder="Введите текст"
                        type="text"
                        value={newChat
                        ?.title}
                        onChange={(e) => setNewChat((prev) => ({
                        ...prev,
                        title: e.target.value
                    }))}/>
                </div>

                <div className={styles.newChatText}>
                    <div className={styles.newChatInputTitle}>Ваше сообщение</div>
                    <textarea
                        className={styles.newChatTextarea}
                        placeholder="Введите текст"
                        value={newChat
                        ?.message}
                        onChange={(e) => setNewChat((prev) => ({
                        ...prev,
                        message: e.target.value
                    }))}/>
                </div>

                <div className={styles.newChatButtons}>
                    <div className={styles.newChatSend} onClick={handleSubmit}>
                        Отправить сообщение
                    </div>
                    <div className={styles.newChatCancel} onClick={() => setNewChat(null)}>
                        Отмена
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index